export default __webpack_public_path__ + "static/media/welcome_pricing.de526ec5.svg";